import { notifications } from "../../constants/actionTypes";

const requestNotificationsList = (data) => ({
  type: notifications.REQUEST_NOTIFICATIONS_LIST,
  payload: data,
});

const successNotificationsList = (data) => ({
  type: notifications.SUCCESS_NOTIFICATIONS_LIST,
  payload: data,
});

const errorNotificationsList = (data) => ({
  type: notifications.ERROR_NOTIFICATIONS_LIST,
  payload: data,
});

const requestReadStatus = (data) => ({
  type: notifications.REQUEST_READ_STATUS,
  payload: data,
});

const successReadStatus = (data) => ({
  type: notifications.SUCCESS_READ_STATUS,
  payload: data,
});

const errorReadStatus = (data) => ({
  type: notifications.ERROR_READ_STATUS,
  payload: data,
});

const setReadStatus = (id) => ({
  type: notifications.SET_READ_STATUS,
  payload: id,
});

export {
  requestNotificationsList,
  successNotificationsList,
  errorNotificationsList,
  requestReadStatus,
  successReadStatus,
  errorReadStatus,
  setReadStatus,
};
